export enum EnglishLabels {
  About_us = "About us",
  Events = "Events",
  Contact_us = "Contact us",
  Social_media = "Social Media",
  Facebook = "Facebook",
  Instagram = "Instagram",
  Youtube = "Youtube",
  X = "X (Twitter)",
  Legal = "Legal",
  Join_us = "Join us",
  Matrimony = "Matrimony",
  Contact_Requests = "Contact Requests",
  Profile_Details = "Profile Details",
  Registration_Guidelines = "Registration Guide",
  Business_Listing = "Business Listings",
  Privacy_Policy = "Privacy Policy",
  Legal_Documents = "Legal Documents",
  Quick_Links = "Quick Links",
  Mourya_Community_Label = "Maurya Kushwaha Samaj, Thane",
  Mourya_Community_Label2 = "Welcome to our digital community, join and empower us.",
  Register = "Register",
  Login = "Login",
  Welcome_Label = "Welcome to the digital world of Maurya Kushwaha Samaj, Thane.",
  Proceed = "Proceed",
  Dont_Have_Account = "Don't have an account?",
  Already_Have_Account = "Already have an account ?",
  Enter_Email = "Enter your email",
  Enter_Password = "Enter password",
  Confirm_Password = "Confirm password",
  Enter_DOB = "Enter your D.O.B",
  Community_Joining_Que = "REASON FOR JOINING COMMUNITY",
  Edit_Button = "Edit",
  Get_In_Touch_With_Us = "Get in Touch with Us",
  Get_In_Touch_With_Us_Des = "Feel free to drop any inquiries or questions, we'll get back to you shortly",
  Home_Page = "Home",
  Donation = "Donation",
  Donate_Page_Header = "Be the Light in Someone’s Life Today",
  Donate_Page_Sub_Header = "Spark Hope, Change Lives, Build Futures",
  Donate_Now = "Donate Now",
  Complete_Your_Donation = "Complete your donation",
  Enter_Verification_Code = "Enter the code sent to your mobile number",
  Complete_Verification_Step_Info = "*Complete the verification step to donate to our community",
  Seconds = "Second",
  Make_Donation_Anonymous = "Make My Donation Anonymous",
  Donors_Name = "Donor Name",
  Ethnicity = "Ethnicity",
  Pan_Number = "PAN Number",
  To_Get_Tax_Benefit = "*Required to get 80G certificate for tax benefits",
  Send_Code = "Send Code",
  Forgot_Password = "Forgot Password?",
  Back_to_Home = "Back to Home",
  Event_Details = "Event Details",
  Community_Guidelines = "Community guidelines",
  Terms_Conditions = "Terms & conditions",
  Matrimony_Guidelines = "Matrimony guidelines",
  Approval_Process = "Approval process",
  Trouble_Logging_In = "Trouble Logging In?",
  Enter_Email_Address_Description = "Enter your email address and we'll send you a link to get back into your account.",
  Get_Reset_Link = "Get Reset Link",
  Need_Help = "Need help?",
  Contact_Support = "Contact Support",
  Back_To_Login = "Back to Login",
  Reset_Link_Sent = "Reset link has been sent to your email.",
  Failed_To_Send_Reset_Link = "Failed to send reset link. Please try again.",
  VERIFY_EMAIL = "Verify Email",
  RESET_PASSWORD = "Reset Password",
  RESET_PASSWORD_SUCCESS = "Password has been reset successfully.",
  FAILED_TO_RESET_PASSWORD = "Failed to reset password. Please try again.",
  TEMP_PASSWORD_MESSAGE = "Please check your email for the temporary password.",
  No_received_requests = "No received requests.",
  Decline_Request_Confirmation = "Decline Request Confirmation",
  Decline_Request_Confirmation_Desc =
    "Are you sure? This request will be removed from your list. The sender will not be notified of this specific action to maintain privacy.",
  Yes_Decline = "Yes, Decline",
  Keep_for_now = "Keep for now",
  Connection_Successful = "Connection Successful!",
  Unable_to_accept_request = "Unable to accept request.",
  Unable_to_decline_request = "Unable to decline request.",
}

export enum Community_Joining_Que_Labels_Eng {
  Marriage_Purpose = "Marriage purpose",
  Business_Purpose = "Business purpose",
  Community_Purpose = "To join sanstha",
  Job_Purpose = "To find job",
}

export enum Regisration_Form_Labels_English {
  BIRTH_DATE = "DATE OF BIRTH",
  GENDER = "GENDER",
  FATHERS_NAME = "FATHER'S NAME",
  MOTHERS_NAME = "MOTHER’S NAME",
  MARITAL_STATUS = "MARITAL STATUS",
  FULL_NAME = "FULL NAME",
  AADHAR_CARD_NUMBER = "AADHAR CARD NUMBER",
  AUTOFILL_ADDRESS = "Save time by auto-filling your current address",
  MOBILE_NUMBER = "MOBILE NUMBER",
  ALTERNATE_MOBILE_NUMBER = "ALTERNATE MOBILE NUMBER",
  EMAIL_ID = "EMAIL ID",
  ALTERNATE_EMAIL_ID = "ALTERNATE EMAIL ID",
  ADDRESS_LINE1 = "ADDRESS LINE 1",
  ADDRESS_LINE2 = "ADDRESS LINE 2",
  PIN_CODE = "PIN CODE",
  STATE = "STATE",
  COUNTRY = "COUNTRY",
  LAST_NAME = "LAST NAME",
  EDUCATIONAL_QUALIFICATION = "EDUCATIONAL QUALIFICATION",
  OCCUPATION = "OCCUPATION",
  EMPLOYER_NAME = "EMPLOYER NAME",
  COMPANY_SIZE = "COMPANY SIZE",
  BUSINESS_DETAILS = "BUSINESS DETAILS",
  POLICY = "I agree to all privacy policy of the organization",
  GO_BACK = "Go back",
  PROCEED = "Save & Proceed",
  SUBMIT = "Submit",
  SAVE = "Save as Draft",
  ORGANIZATION = "Organization",
  MANDATORY = "is Mandatory"
  
}

export enum Stepper_labels_English {
  PERSONAL_DETAILS = "Personal Details",
  COMMUNICATION_DETAILS = "Communication Details",
  CONFIRMATION = "Confirmation",
}

export enum Profile_Tab_English {
  FAMILY = "Family",
  COMMUNICATION_DETAILS = "Communication Details",
  ABOUT = "About",
  ADDRESS = "Address",
  PROFESSIONAL_BACKGROUND = "Professional Background",
  MARRIAGE_REGISTRATION = "Marriage Registration"
}

export enum Admin_Labels_Eng {
  PENDING_APPROVAL_REQUESTS = "Pending Approval Requests",
  APPROVE_ALL = "Approve All",
  REJECT_ALL = "Reject All",
  APPROVE = "Approve",
  REJECT = "Reject",
  NAME = "Name",
  REASON_FOR_JOINING = "Reason for Joining",
  MOBILE_NO = "Mobile No.",
  DOB = "DOB",
  ACTION = "Action",
  ADMIN_DASHBOARD = "Admin Dashboard",
  TOTAL_REGISTERED_USERS = "Total Registered Users",
  PENDING_APPROVALS = "Pending Approvals",
  ACCEPTED_USERS = "Accepted Users",
  REJECTED_USERS ="Rejected Users",
  ADMIN_INFO = "Admin Info",
  ADMIN = "Admin",
  ADMIN_MANAGEMENT="Admin Management",
  MATRIMONY_PROFILES = "Matrimony Profiles",
  MARRIAGE_CONSULTANTS = "Marriage Consultants",
  EMAIL = "Email",
  ADMIN_EMAIL = "Admin Email",
  ROLE = "Role",
  STATUS = "Status",
  BLOCKED = "Blocked",
  No_User_Approval_Pending = "No User Approvals Pending",
  NO_HISTORY_FOUND = "No history found",
  REASON = "Reason",
  TIMESTAMP = "TimeStamp",  
  ALL = "All",
  Approval_Status_Distribution="Approval Status Distribution",
  User_Approval_History="User Approval History"
}

export enum PROFILE_HEADINGS_ENG {
  ORGANIZATION = "Organization",
  OCCUPATION = "Occupation",
  EDUCATIONAL_QUALIFICATION = "Educational Qualification",
  UNIVERSITY = "University",
  GRADUATION_YEAR = "Graduation Year",
  AGE = "Age",
  CURRENT_ADDRESS = "Current Address",
  PERMENANT_ADDRESS = "Permanent Address",
  BUSINESS_DETAILS = "Business Details",
  ADD_FAMILY_MEMBER = "Add family member",
}

export enum ABOUT_ENG {
  BIO = "Bio",
  DOB = "Date of Birth",
  AGE = "Age",
  GENDER = "Gender",
  MARITAL_STATUS = "Marital Status",
  AADHAR = "Aadhar No.",
}

export enum COMMUNICATION_DETAILS_ENG {
  MOBILE_NUMBER = "Mobile No.",
  EMAIL_ID = "Email ID",
  ALTERNATE_MOBILE_NUMBER = "Alternate Mobile No.",
  ALTERNATE_EMAIL_ID = "Alternate Email ID",
}

export enum PROFESSIONAL_BACKGROUND_ENG {
  OCCUPATION = "Occupation",
  ORGANIZATION = "Organization",
  EDUCATIONAL_QUALIFICATION = "Educational Qualification",
  UNIVERSITY = "University",
  GRADUATION_YEAR = "Year of Graduation",
  BUSINESS_DETAILS = "Business Details",
}

export enum LANDING_PAGE_LABELS_ENG {
  CELEBRATING_UNITY_AND_TRADITION = "Celebrating Unity & Tradition",
  ABOUT_OUR_COMMUNITY = "About Our Community",
  A_VAST_COMMUNITY_OF = "A vast community of",
  SANSTHAS = "Sansthas",
  LIFETIME_MEMBERS = "Lifetime Members",
  GENERAL_MEMBERS = "General Members",
  EVENTS = "Events",
}

export enum ABOUT_US_ENG {
  ABOUT_OUR_COMMUNITY_1 = "Maurya Kushwaha Samaj, Thane, was established on February 14, 1993, and officially registered on February 14, 1994. This organization is dedicated to promoting unity and brotherhood among members of the Maurya and Kushwaha communities. Our mission is to preserve cultural heritage, encourage social development, and empower individuals through various initiatives and programs.",
  ABOUT_OUR_COMMUNITY_2 = "We organize conferences, business summits, and cultural programs to provide platforms for networking, knowledge sharing, and community growth. Our active presence on social media enables us to connect with members, share updates, and engage in meaningful discussions.",
  ABOUT_OUR_COMMUNITY_3 = "Through our efforts, we aim to create a cohesive and supportive environment that encourages personal and professional development, while preserving the rich traditions of the Maurya and Kushwaha communities.",
}

export enum EVENTS_ENG {
  UPCOMING_EVENTS = "Upcoming Events",
  RECENT_EVENTS = "Recent Events",
}

export enum BUTTONS_ENG {
  VIEW_ALL = "View All",
  EDIT = "Edit",
  NEXT = "Next",
  PREV = "Prev"
}
 export enum STATUS_LABELS_ENG {
  APPROVED = "Approved",
  PENDING = "Pending",
  REJECTED = "Rejected",
}
